var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2718 -964 26 20.234"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-2692.37-958.907-14.894 14.778a1.25 1.25 0 0 1-1.767-.007l-8.607-8.671a1.25 1.25 0 0 1 .007-1.769l2.959-2.935a1.25 1.25 0 0 1 1.765.004l4.791 4.829 11.051-10.959a1.25 1.25 0 0 1 1.767.007l2.935 2.959a1.25 1.25 0 0 1-.007 1.769Z"
  })));
};
export default SvgCheck;